import * as actions from "store/oneDaySale/oneDaySale.types";
import { IAppraisalTable } from "types/dealTypes";

export const pendingGetOneDaySaleAppraisal = (): actions.GetOneDaySaleAppraisalPending => {
  return {
    type: actions.GET_ONE_DAY_SALE_APPRAISAL_PENDING,
  };
};


export const handleGetOneDaySaleAppraisal = ({
  formData, callback
}: any): actions.HandleGetOneDaySaleAppraisal => {
  return {
    type: actions.HANDLE_GET_ONE_DAY_SALE_APPRAISAL,
    payload: { formData, callback },
  };
};

export const resolvedGetOneDaySaleAppraisal = (
  results: any,
): actions.GetOneDaySaleAppraisalResolved => {
  return {
    type: actions.GET_ONE_DAY_SALE_APPRAISAL_RESOLVED,
    payload: {results},
  };
};

export const rejectedGetOneDaySaleAppraisal = (
  errors: any
): actions.GetOneDaySaleAppraisalRejected => {
  return {
    type: actions.GET_ONE_DAY_SALE_APPRAISAL_REJECTED,
    payload: errors,
  };
};


export const handleUpdateOneDaySaleAppraisal = ({
id, data, callback}
): actions.HandleUpdateOneDaySaleAppraisal => {
  return {
    type: actions.HANDLE_UPDATE_ONE_DAY_SALE_APPRAISAL,
    payload: {id, data, callback},
  };
};


export const handleCreateOneDaySaleAppraisal = ({
  saleDate,
  callback,
}: any): actions.HandleCreateOneDaySaleAppraisal => {
  return {
    type: actions.HANDLE_CREATE_ONE_DAY_SALE_APPRAISAL,
    payload: { saleDate, callback },
  };
};

export const pendingGetOneDaySaleAppraisalById = (): actions.GetOneDaySaleAppraisalByIdPending => {
  return {
    type: actions.GET_ONE_DAY_SALE_APPRAISAL_BY_ID_PENDING,
  };
};


export const handleGetOneDaySaleAppraisalById = ({
  id,callback
}: any): actions.HandleGetOneDaySaleAppraisalById => {
  return {
    type: actions.HANDLE_GET_ONE_DAY_SALE_APPRAISAL_BY_ID,
    payload:{ id ,callback} ,
  };
};

export const resolvedGetOneDaySaleAppraisalById = (
  results: any,
): actions.GetOneDaySaleAppraisalByIdResolved => {
  return {
    type: actions.GET_ONE_DAY_SALE_APPRAISAL_BY_ID_RESOLVED,
    payload: {results},
  };
};

export const rejectedGetOneDaySaleAppraisalById = (
  errors: any
): actions.GetOneDaySaleAppraisalByIdRejected => {
  return {
    type: actions.GET_ONE_DAY_SALE_APPRAISAL_BY_ID_REJECTED,
    payload: errors,
  };
};

//
export const pendingGetOneDaySaleDate = (): actions.GetOneDaySaleDatePending => {
  return {
    type: actions.GET_ONE_DAY_SALE_DATE_PENDING,
  };
};


export const handleGetOneDaySaleDate = ({
  formData,
}: any): actions.HandleGetOneDaySaleDate => {
  return {
    type: actions.HANDLE_GET_ONE_DAY_SALE_DATE,
    payload: { formData },
  };
};

export const resolvedGetOneDaySaleDate = (
  results: any,
): actions.GetOneDaySaleDateResolved => {
  return {
    type: actions.GET_ONE_DAY_SALE_DATE_RESOLVED,
    payload: {results},
  };
};

export const rejectedGetOneDaySaleDate = (
  errors: any
): actions.GetOneDaySaleDateRejected => {
  return {
    type: actions.GET_ONE_DAY_SALE_DATE_REJECTED,
    payload: errors,
  };
};

export const pendingGetOneDaySaleWorkbook = (): actions.GetOneDaySaleWorkbookPending => {
  return {
    type: actions.GET_ONE_DAY_SALE_WORKBOOK_PENDING,
  };
};


export const handleGetOneDaySaleWorkbook = ({
  formData,
  callback
}: any): actions.HandleGetOneDaySaleWorkbook => {
  return {
    type: actions.HANDLE_GET_ONE_DAY_SALE_WORKBOOK,
    payload: { formData ,callback},
  };
};

export const resolvedGetOneDaySaleWorkbook = (
  results: any,
): actions.GetOneDaySaleWorkbookResolved => {
  return {
    type: actions.GET_ONE_DAY_SALE_WORKBOOK_RESOLVED,
    payload: {results},
  };
};

export const rejectedGetOneDaySaleWorkbook = (
  errors: any
): actions.GetOneDaySaleWorkbookRejected => {
  return {
    type: actions.GET_ONE_DAY_SALE_WORKBOOK_REJECTED,
    payload: errors,
  };
};



export const handleUpdateOneDaySaleDate = ({
  id,
  saleDate,
  callback,
}): actions.HandleUpdateOneDaySaleDate => {
  return {
    type: actions.HANDLE_UPDATE_ONE_DAY_SALE_DATE,
    payload: {id, saleDate, callback},
  };
};


export const handleCreateOneDaySaleDate = ({
  saleDate,
  callback,
}: any): actions.HandleCreateOneDaySaleDate => {
  return {
    type: actions.HANDLE_CREATE_ONE_DAY_SALE_DATE,
    payload: { saleDate, callback },
  };
};

/* One Day Sale Notes*/

export const HandleSaveOneDaySaleNotes= ({details, callback}): actions.HandleSaveOneDaySaleNotes => {
  return {
      type: actions.HANDLE_SAVE_ONE_DAY_SALE_NOTES,
      payload: {details,callback}
  }
};

export const HandleGetOneDaySaleNotes = (params): actions.HandleGetOneDaySaleNotes => {
  return {
      type: actions.HANDLE_GET_ONE_DAY_SALE_NOTES,
      payload: params
  }
};

export const handleDeleteOneDaySaleDate= ({
  id, callback
}:any): actions.HandleDeleteOneDaySaleDate => {
  return {
    type: actions.HANDLE_DELETE_ONE_DAY_SALE_DATE,
    payload: { id, callback },
  };
};

export const handleGetAppraisalTrimUsingVin = ({
  vin,
  callback
}): actions.HandleGetAppraisalTrimUsingVin => {
return {
  type: actions.HANDLE_GET_APPRAISAL_TRIM_VIN,
  payload: {
      vin,
      callback
  },
};
};


export const handleGetAppraisalVehDetails = ({
  vehDet,
  callback
}): actions.HandleGetAppraisalVehDetails => {
return {
  type: actions.HANDLE_GET_APPRAISAL_VEH_DETAILS,
  payload: {
      vehDet,
      callback
  },
};
};

export const handleSelectedOneDaySaleTradeIn = (tradeInData: any): actions.HandleSelectedOneDaySaleTradeIn => {
  return {
      type: actions.HANDLE_SELECTED_ONEDAYSALE_TRADEIN,
      payload: tradeInData,
  };
};

export const pendingGetOneDayAppraisalTable = (): actions.GetOneDayAppraisalTablePending => {
    return {
        type: actions.GET_ONE_DAY_APPRAISAL_TABLE_LIST_PENDING,
    };
};

export const handleGetOneDayAppraisalTable = (tradeInId: number | string, callback?: (error: any, data: any) => void) => {
    return {
        type: actions.HANDLE_GET_ONE_DAY_APPRAISAL_TABLE_LIST,
        payload: { tradeInId, callback },
    };
};

export const resolvedGetOneDayAppraisalTable = (
    results: IAppraisalTable[]
): actions.GetOneDayAppraisalTableResolved => {
    return {
        type: actions.GET_ONE_DAY_APPRAISAL_TABLE_LIST_RESOLVED,
        payload: { results },
    };
};

export const rejectedGetOneDayAppraisalTable = (
    errors: any
): actions.GetOneDayAppraisalTableRejected => {
    return {
        type: actions.GET_ONE_DAY_APPRAISAL_TABLE_LIST_REJECTED,
        payload: errors,
    };
};

// CREATE ONE_DAY APPRAISAL_TABLE_LIST

export const handleCreateOneDayAppraisalTableItem = (
    formData: any
): actions.HandleCreateOneDayAppraisalTableItem => {
    return {
        type: actions.HANDLE_CREATE_ONE_DAY_APPRAISAL_TABLE_LIST_ITEM,
        payload: formData
    };
};

export const handleSearchOneDaySaleDealRecord = ({
  deal,
  callback,
}): actions.HandleSearchOneDaySaleDealRecord => {
  return {
      type: actions.HANDLE_SEARCH_ONE_DAY_SALE_DEAL_RECORD,
      payload: {deal, callback },
  };
};

export const handleCreateOneDaySaleDealRecord = ({
  deal,
  callback,
}): actions.HandleCreateOneDaySaleDealRecord => {
  return {
      type: actions.HANDLE_CREATE_ONE_DAY_SALE_DEAL_RECORD,
      payload: { deal, callback },
  };
};


export const handleCreateAppraisalFormValue = (
    formData: any,
    callback: (id: number | null) => void
): actions.HandleCreateAppraisalFormValue => {
    return {
        type: actions.HANDLE_CREATE_APPRAISAL_FORM_VALUE,
        payload: { formData, callback }  // Add callback to handle response
    };
};

export const handleShowOnedaySaleWarning = (
  formData: any,
): actions.HandleShowOnedaySaleWarning => {
  return {
      type: actions.HANDLE_SHOW_ONEDAY_SALE_WARNING,
      payload: { formData}  
  };
};

export const resolvedOnedaySaleWarning = (
  formData: any,
): actions.HandleShowOnedaySaleWarningResolved => {
  return {
      type: actions.HANDLE_SHOW_ONEDAY_SALE_WARNING_RESOLVED,
      payload: { formData}  
  };
};

export const handleAddOneDaySaleToDealTradeIn = ({
  deal,
  callback
}:any): actions.HandleAddOneDaySaleToDealTradeIn => {
  return {
      type: actions.HANDLE_ADD_ONE_DAY_SALE_TO_DEAL_TRADEIN,
      payload: { deal, callback }
  };
};

export const handleDeleteOneDaySale = ({
  id,
  callback
}:any): actions.HandleDeleteOneDaySale => {
  return {
      type: actions.HANDLE_DELETE_ONE_DAY_SALE,
      payload: { id, callback }
  };
};

